export default "__VITE_ASSET__DTiLEBiY__"